export default __webpack_public_path__ + "static/media/sign-in-background.fd37be31.jpg";